import React from 'react'
import './Map.css'

const Map = () => {
    return (

<div className="container-fluid map">
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      justifyContent: "center",
    }}
  >
    {/* 🗺️ Noida Office */}
    <iframe
      title="Noida Office"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1701.8798132271784!2d77.31223818837991!3d28.58485223652218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a6f57cf8fd%3A0x7cbdf4a92ebfcac7!2sTechTorch%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1760283574864!5m2!1sen!2sin"
      style={{
        flex: 1,
        minWidth: "350px",
        maxWidth: "600px",
        height: "320px",
        border: "none",
        borderRadius: "12px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
      }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>

    {/* 🗺️ Bareilly Office */}
    <iframe
      title="Bareilly Office"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.967247293842!2d79.4325611!3d28.390057199999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a0075957e78e9f%3A0xf1d5b04ea8b3ab01!2sTechTorch%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1769448862109!5m2!1sen!2sin"
      style={{
        flex: 1,
        minWidth: "350px",
        maxWidth: "600px",
        height: "320px",
        border: "none",
        borderRadius: "12px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
      }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div>



    )
}

export default Map
